/**
 * @fileoverview POST handler for the "/engagement/location_sets_update_archived_state" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementLocationSetsUpdateArchivedStateCacheKeys } from "./constants";
import type {
  EngagementLocationSetsUpdateArchivedStateSuccessResult,
  PostEngagementLocationSetsUpdateArchivedStateProps,
} from "./types";
import { isErrorResult } from "./types";
import { FetchRequestError } from "@lib/errors";

export const postEngagementLocationSetsUpdateArchivedState = reactQueryMutationAdapter(
  engagementLocationSetsUpdateArchivedStateCacheKeys,
  ({
    mark_as_archived: markAsArchived,
    location_set_ids,
    undo_identifier,
  }: PostEngagementLocationSetsUpdateArchivedStateProps): Promise<EngagementLocationSetsUpdateArchivedStateSuccessResult> => {
    return fetch("/engagement/location_sets_update_archived_state", "POST", {
      archive: markAsArchived,
      location_set_ids,
      undo_identifier,
    }).then((result) => {
      if (isErrorResult(result)) {
        throw new FetchRequestError(400, result.warn);
      }
      return { ...result, undo_data: { ...result.undo_data, reenable: [] } };
    });
  }
);
